<template>
  <div :class="indicatorClass">
  </div>
</template>

<script>
export default {
  name: 'ConnectionStateIndicator',
  computed: {
    indicatorClass() {
      return this.$store.state.backConnected ? 'connected' : 'not-connected';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.connected{
  margin-top: 25px;
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background-color: #006404;
  float: left;
  border-radius: 15px;
  box-shadow: 0em 0em 0.4em #006404;
}
.not-connected{
  margin-top: 25px;
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background-color: #ae0000;
  float: left;
  border-radius: 15px;
  box-shadow: 0em 0em 0.4em #ae0000;
}
</style>
